import { CheckCircle2 } from "lucide-react";
import { IMAGES } from "@/config";
import { Reveal, CtaButton, Highlight, SectionTitle, ImageSlot } from "./Primitives";

const PARTS = [
  {
    tag: "PART 01",
    title: "Crack The Code",
    body: "We'll look at how money really flows through an Indian household, what's quietly blocking growth, and what the wealthy do differently.",
    afterLabel: "After Part 1, you will see …",
    after: ["Where your money actually goes", "Why most people stay stuck", "The wealth habits nobody teaches", "How compounding really works"],
    img: IMAGES.part1,
    imgLabel: "Sandeep Gupta teaching a live audience",
    pos: "62% center",
  },
  {
    tag: "PART 02",
    title: "Build Your Wealth Plan",
    body: "You'll see how to put the code into action with a simple, step-by-step approach your family can follow.",
    afterLabel: "After Part 2, you will …",
    after: ["Know the right order to fix your finances", "See how to protect what you build", "Walk away with a clear next step"],
    img: IMAGES.part2,
    imgLabel: "Sandeep Gupta with a cheering audience",
    pos: "center 30%",
    flip: true,
  },
];

const PartBlock = ({ p, i }) => (
  <Reveal className="rounded-2xl bg-white border border-plum/10 shadow-[0_20px_50px_-30px_rgba(42,15,92,0.5)] overflow-hidden" data-testid={`part-${i + 1}`}>
    <div className="plum-band px-4 sm:px-6 py-3 text-white">
      <span className="inline-block bg-ink text-white text-[11px] font-bold tracking-wider rounded px-2 py-0.5">{p.tag}</span>
      <h3 className="font-extrabold text-lg sm:text-2xl mt-1">{p.title}</h3>
    </div>
    <div className={`grid md:grid-cols-2 gap-5 p-4 sm:p-6 items-center ${p.flip ? "md:[&>*:first-child]:order-2" : ""}`}>
      <div>
        <p className="text-[14px] text-zinc-700 leading-relaxed">{p.body}</p>
        <div className="mt-4 rounded-xl border-2 border-dashed border-green-400 bg-green-50/60 p-4">
          <p className="font-bold text-ink text-sm mb-2">{p.afterLabel}</p>
          <ul className="space-y-2">
            {p.after.map((t) => (
              <li key={t} className="flex gap-2 text-[13.5px] text-zinc-800"><CheckCircle2 className="w-4.5 h-4.5 w-[18px] h-[18px] text-green-600 shrink-0 mt-px" />{t}</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="aspect-[4/3] rounded-xl overflow-hidden clip-frame">
        <ImageSlot src={p.img} label={p.imgLabel} position={p.pos} testId={`part-${i + 1}-image-slot`} />
      </div>
    </div>
  </Reveal>
);

export const Parts = () => (
  <section className="px-4 py-12 sm:py-16 bg-[#F7F4FC]" data-testid="parts-section">
    <div className="max-w-5xl mx-auto">
      <Reveal className="text-center">
        <span className="inline-block rounded bg-plum/10 text-plum text-[11px] sm:text-[12px] font-bold tracking-wider uppercase px-3 py-1 mb-3">During The Wealth Code Masterclass</span>
        <SectionTitle>Here's What <Highlight>You'll Learn</Highlight></SectionTitle>
      </Reveal>
      <div className="space-y-6 mt-8">
        {PARTS.map((p, i) => <PartBlock key={p.tag} p={p} i={i} />)}
      </div>
      <div className="max-w-xl mx-auto mt-8"><CtaButton testId="parts-cta-button" /></div>
    </div>
  </section>
);
